import React, { useState, useEffect } from "react";
import "./SideApp.css";

const UserInfoDetails = ({ selectedUser }) => {
    const [infoDetails, setInfoDetails] = useState(null);
    const [editedInfoDetails, setEditedInfoDetails] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [orders, setOrders] = useState([]);
    const [available, setAvailable] = useState(0);
    const [pending, setPending] = useState(0);

    useEffect(() => {
        if (selectedUser) {
            const fetchInfoDetails = async () => {
                try {
                    const response = await fetch(
                        `https://bymolive-backend-995926394015.us-central1.run.app/api/all-collections`
                    );
                    if (!response.ok) throw new Error("Failed to fetch user collections.");
                    const data = await response.json();

                    // Extract the `00info` document for the selected user
                    const userDocs = data[selectedUser.email];
                    if (!userDocs) {
                        throw new Error(`No documents found for ${selectedUser.email}`);
                    }

                    const infoDoc = userDocs.find((doc) => doc.id === "00info");
                    if (!infoDoc) {
                        throw new Error(`No "00info" document found for ${selectedUser.email}`);
                    }

                    // Remove the "id" field from the "00info" document
                    const { id, ...infoWithoutId } = infoDoc;


                    setInfoDetails(infoWithoutId);
                    setEditedInfoDetails(infoWithoutId);

                    // Extract and set orders
                    const orders = userDocs.filter((doc) => doc.id !== "00info");
                    setOrders(orders);

                    // Compute stats
                    const availableSum = orders
                        .filter((order) => ["aprobat", "user"].includes(order.status))
                        .reduce((sum, order) => sum + (order.comision || 0), 0);
                    const pendingSum = orders
                        .filter((order) => order.status === "in asteptare")
                        .reduce((sum, order) => sum + (order.comision || 0), 0);

                    setAvailable(availableSum);
                    setPending(pendingSum);
                } catch (error) {
                    console.error("Error fetching info details:", error);
                }
            };

            fetchInfoDetails();
        }
    }, [selectedUser]);

    const handleFieldChange = (key, value) => {
        setEditedInfoDetails((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSaveInfoDetails = async () => {
        try {
            const response = await fetch(
                "https://bymolive-backend-995926394015.us-central1.run.app/api/update-collection",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        collection: selectedUser.email,
                        document: { ...editedInfoDetails, id: "00info" },
                    }),
                }
            );
            if (!response.ok) throw new Error("Failed to save info details.");
            setSuccessMessage("Details saved successfully!");
        } catch (error) {
            console.error("Error saving info details:", error);
        }
    };

    if (!infoDetails) {
        return <p>Loading details...</p>;
    }

    return (
        <div className="user-info-details-container">


            {/* Stats Section */}
            <div className="stats-section">
                <h3>Stats</h3>
                <p>
                    <strong>Available:</strong> {available.toFixed(2)}
                </p>
                <p>
                    <strong>Pending:</strong> {pending.toFixed(2)}
                </p>
            </div>

            {/* Divider */}
            <div className="divider"></div>
            {/* Details Section */}
            <div className="details-section">
                <h3>Details for {selectedUser.email}</h3>
                <table className="info-details-table">
                    <tbody>
                    {Object.entries(editedInfoDetails).map(([key, value]) => (
                        <tr key={key}>
                            <td>{key}</td>
                            <td>
                                <input
                                    type="text"
                                    value={value}
                                    onChange={(e) => handleFieldChange(key, e.target.value)}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <button onClick={handleSaveInfoDetails}>Save Info</button>
                {successMessage && <p className="success-message">{successMessage}</p>}
            </div>
        </div>
    );
};

export default UserInfoDetails;
